<template>
	<div class="jup-route">
		<table class="table table-sm table-borderless table-no-hover xsmall" v-if="route">
			<tbody>
			<tr>
				<td>Minimum Received</td>
				<td>{{ route.otherAmountThreshold / Math.pow(10, tokenB.decimals) }} {{ tokenB.symbol }}</td>
			</tr>
			<tr>
				<td>Price Impact</td>
				<td>{{ Number(route.priceImpactPct).toFixed(4) }}%</td>
			</tr>
			<tr>
				<td>Transaction Fee</td>
				<td>{{ transactionFee.toPrecision(9) }} SOL</td>
			</tr>
			<tr>
				<td>Route</td>
				<td class="route-info">
					<span v-for="(r, key) in route.routePlan" :key="key">
						<span class="alert alert-sm xsmall border-dark p-1 ms-2">{{r.swapInfo.label}}</span>
					</span>
				</td>
			</tr>
			</tbody>
		</table>
		<table class="table table-sm table-borderless xsmall" v-else>
			<tbody>
			<tr>
				<td>Minimum Received</td>
				<td>Loading...</td>
			</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	name: "JupiterRoute",
	props: {
		route: {
			type: Object,
		},
		tokenA: {
			type: Object,
			required: true,
		},
		tokenB: {
			type: Object,
			required: true,
		}
	},
	computed: {
		transactionFee: function () {
			let lamports = 5000 + Number(this.route.platformFee?.amount)

			lamports += (this.$store.getters['settings/priorityFee'] / 1_000_000)

			const vTip = this.$store.getters['settings/validatorTip']
			if (vTip > 0)
				lamports += vTip

			return lamports / Math.pow(10, 9)
		}
	}
}
</script>

<style scoped>
tr :last-child {
	text-align: end;
}

.route-info {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: flex-end;
	align-items: center;
}

.xsmall {
	font-size: .75em;
}

.xsmall td{
	font-size: .75em;
}
</style>